import { render, staticRenderFns } from "./ModalDisable.vue?vue&type=template&id=970be9ee"
import script from "./ModalDisable.vue?vue&type=script&lang=js"
export * from "./ModalDisable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports